import { exists, t } from 'i18next';

export const translation = (key: string) => {
  const isNotExists = !exists(key);

  if (isNotExists) {
    console.error(`존재하는 키가 없습니다.\n존재하지 않는 키: ${key}`);
  }
  const translationResult = t(key);
  return translationResult;
};
